import index from "./sanalAsuulga.vue";
export default index;
